import {
  BackgroundContainer,
  StyledContainerProps,
} from "@components/Styled/Container";
import { mapStylesToClassNames } from "@lib/styles";
import { ComponentProps } from "@ts/components";
import { Styles } from "@ts/sanity";
import React from "react";
import tw from "twin.macro";

type CommonContainerProps = ComponentProps & {
  styles: Styles[] | null;
};

type LegacyContainerProps = StyledContainerProps & {
  legacy: true;
};

type NewContainerProps = {
  legacy?: false;
};

type ContainerProps = CommonContainerProps &
  (LegacyContainerProps | NewContainerProps);

const Wrapper = tw.section`overflow-auto`;

const Container = ({
  children,
  styles,
  legacy = false,
  className,
  ...rest
}: ContainerProps) => {
  if (legacy) {
    return (
      <BackgroundContainer className="overflow-auto" {...rest}>
        {children}
      </BackgroundContainer>
    );
  }

  const classNamesFromStyleProps = mapStylesToClassNames(styles);
  const classNames = [className, classNamesFromStyleProps];
  const combinedClassNames = classNames.join(" ");

  return (
    <Wrapper className={combinedClassNames} {...rest}>
      {children}
    </Wrapper>
  );
};

export default Container;
